import React, { FC } from 'react';
import { animated, useSpring } from 'react-spring';

import { SpacingTypes } from '@folx-types/theme';

import CaretSolid from '@assets/vectors/caret-solid.inline.svg';

import theme from '@theme/FolxTheme';

interface IAnimatedCaretProps {
	open: boolean;
	width?: SpacingTypes;
}

const Caret = animated(CaretSolid);

const AnimatedCaret: FC<IAnimatedCaretProps> = ({ open, width = 'sm' }) => {
	const flipAnimation = useSpring({
		transform: `scaleY(${open ? -1 : 1})`,
		width: theme.spacing[width],
		flexShrink: 0,
	});
	return <Caret style={flipAnimation} />;
};

export default AnimatedCaret;
